import { ShopGroupsPage } from 'features/shop-groups';

export const TechOperatorShopGroupsPage: React.FC = () => <ShopGroupsPage />;
